import { Grid } from "@mui/material";
import React from "react";
import Typography from "@mui/material/Typography";
import { AdvoAssist } from "../../types/AdvoAssist/AdvoAssist";
import { Appointment } from "../../types/Appointment";
import dayjs from "dayjs";

type AdvoAssistDataProps = {
  advoAssist: AdvoAssist;
  legalbirdAppointment: Appointment;
};
export default function AdvoAssistData({ advoAssist, legalbirdAppointment }: AdvoAssistDataProps) {
  const details = advoAssist.appointmentDetails!;
  const advoAssistAppointmentDate = dayjs(details.termin);
  const legalbirdAppointmentDate = dayjs(legalbirdAppointment.appointmentDateTime);
  return (
    <>
      <Grid size={12}>
        <Typography variant={"h5"} color={"primary"} sx={{ mt: 1, mb: 1 }}>
          Basisdaten
        </Typography>
      </Grid>
      <Grid size={12}>
        <Grid container spacing={2}>
          <Grid
            size={{
              md: 2,
              sm: 6,
              xs: 12
            }}>
            Datum (LB):
          </Grid>
          <Grid
            size={{
              md: 4,
              sm: 6,
              xs: 12
            }}>
            {legalbirdAppointmentDate.format("DD.MM.YYYY HH:mm:ss")}
          </Grid>

          <Grid
            size={{
              md: 2,
              sm: 6,
              xs: 12
            }}>
            Datum (AA):
          </Grid>
          <Grid
            size={{
              md: 4,
              sm: 6,
              xs: 12
            }}>
            {advoAssistAppointmentDate.format("DD.MM.YYYY HH:mm:ss")}
          </Grid>

          <Grid
            size={{
              md: 2,
              sm: 6,
              xs: 12
            }}>
            Eingestellt:
          </Grid>
          <Grid
            size={{
              md: 4,
              sm: 6,
              xs: 12
            }}>
            {dayjs(details.einstellzeit).format("DD.MM.YYYY HH:mm:ss")}
          </Grid>

          <Grid
            size={{
              md: 2,
              sm: 6,
              xs: 12
            }}>
            Angenommen:
          </Grid>
          <Grid
            size={{
              md: 4,
              sm: 6,
              xs: 12
            }}>
            {details.annahmezeit !== "0000-00-00 00:00:00"
              ? dayjs(details.annahmezeit).format("DD.MM.YYYY HH:mm:ss")
              : "Noch nicht angenommen"}
          </Grid>
        </Grid>
      </Grid>
      <Grid size={12}>
        <Typography variant={"h5"} color={"primary"} sx={{ mt: 1, mb: 1 }}>
          Terminsvertreter
        </Typography>
        <Grid container spacing={2}>
          {!advoAssist.lawyerDetails ? (
            <Grid size={12}>
              Es wurde noch kein Terminsvertreter ausgewählt
            </Grid>
          ) : (
            <>
              <Grid
                size={{
                  md: 2,
                  sm: 6,
                  xs: 12
                }}>
                Anwalt:
              </Grid>
              <Grid
                size={{
                  md: 4,
                  sm: 6,
                  xs: 12
                }}>
                {advoAssist.lawyerDetails.adressat}
              </Grid>

              <Grid
                size={{
                  md: 2,
                  sm: 6,
                  xs: 12
                }}>
                Kanzlei:
              </Grid>
              <Grid
                size={{
                  md: 4,
                  sm: 6,
                  xs: 12
                }}>
                {advoAssist.lawyerDetails.name}
              </Grid>

              <Grid
                size={{
                  md: 2,
                  sm: 6,
                  xs: 12
                }}>
                E-Mail:
              </Grid>
              <Grid
                size={{
                  md: 4,
                  sm: 6,
                  xs: 12
                }}>
                {advoAssist.lawyerDetails.email}
              </Grid>

              <Grid
                size={{
                  md: 2,
                  sm: 6,
                  xs: 12
                }}>
                Telefon:
              </Grid>
              <Grid
                size={{
                  md: 4,
                  sm: 6,
                  xs: 12
                }}>
                <a href={"tel:" + advoAssist.lawyerDetails.telefon}>{advoAssist.lawyerDetails.telefon}</a>
              </Grid>
            </>
          )}
        </Grid>
      </Grid>
      <Grid size={12}>
        <Typography variant={"h5"} color={"primary"} sx={{ mt: 1, mb: 1 }}>
          Gutschrift
        </Typography>
        <Grid container spacing={2}>
          {!advoAssist.creditNoteCreated ? (
            <>
              <Grid size={12}>
                Es wurde noch keine Terminsvertreter Gutschrift erstellt
              </Grid>
            </>
          ) : (
            <>
              <Grid
                size={{
                  md: 2,
                  sm: 6,
                  xs: 12
                }}>
                Erstellt am:
              </Grid>
              <Grid
                size={{
                  md: 4,
                  sm: 6,
                  xs: 12
                }}>
                {dayjs(advoAssist.creditNoteCreated).format("DD.MM.YYYY")}
              </Grid>

              <Grid
                size={{
                  md: 2,
                  sm: 6,
                  xs: 12
                }}>
                Zahllauf:
              </Grid>
              <Grid
                size={{
                  md: 4,
                  sm: 6,
                  xs: 12
                }}>
                {advoAssist.paymentRun
                  ? (advoAssist.paymentRun.paid && dayjs(advoAssist.paymentRun.paid).format("DD.MM.YYYY")) +
                    " [id:" +
                    advoAssist.paymentRun.id +
                    "]"
                  : "noch nicht im Zahllauf"}
              </Grid>
            </>
          )}
        </Grid>
      </Grid>
    </>
  );
}
